export default __webpack_public_path__ + "static/verso-1-1c97815011e8f3fc036818cc45ce066a.jpg";